<template>
    <div id="ContainerUser">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">{{ $t('UnifiedProfile.Title') }}</h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                        <MdButton
                            v-bind:Label="$t('UnifiedProfile.Add')"
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddUser"
                            v-bind:Name="'btn_add_users'"
                        >
                        </MdButton>
                    </div>
                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-9 mb-4'
                                : 'col-sm-12 col-md-9 mb-4'
                        "
                    >
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="SearchUsers"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchUsers"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <MdSelect
                            v-bind:Label="$t('Shared.Status')"
                            v-bind:Options="ListStatus"
                            v-bind:ModelArray="status"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            :Input="ChangeStatus"
                        />
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <MdSelect
                            v-bind:Label="$t('userHeader.PasswordStatus')"
                            v-bind:Options="PasswordListStatus"
                            v-bind:ModelArray="passwordStatus"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            :Input="ChangePasswordStatus"
                        />
                    </div>
                    <div class="col-sm-12 col-md-3">
                        <MdSelect
                            v-bind:Label="$t('userHeader.Role')"
                            data-field="Role"
                            v-bind:Options="RoleList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="Rol"
                            :Input="ChangeRol"
                        />
                    </div>
                    <b-col lg="3" md="3" sm="12">
                        <div class="text-center text-md-right mt-3">
                            <button
                                type="button"
                                v-on:click="SearchUsers"
                                class="btn btn-primary btn-login mx-2 pull-right"
                                id="btnsearchinputUser"
                            >
                                {{ $t('Shared.Search') }}
                            </button>
                        </div>
                    </b-col>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            v-bind:FieldsDate="FieldsDateArr"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            v-bind:IsuserHeader="true"
                            :editIconEvent="EditUser"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="PerPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UsersService from '@/services/users.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission';
import moment from 'moment';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'UnifiedProfile',
    data() {
        return {
            patient: {},
            userCode: '',
            ShowMessageIsEmpty: false,
            Mode: '',
            ListStatus: EnumService.PatientListStatus,
            PasswordListStatus: EnumService.PasswordListStatus,
            status: {
                selected: true,
                value: true,
                text: this.$t('Shared.Active')
            },
            passwordStatus: {
                selected: true,
                value: 'All',
                text: this.$t('Shared.All')
            },
            FieldsDateArr: ['expirationDate'],
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
                PatientCode: ''
            },
            fields: [
                {
                    key: 'userName',
                    sortable: true,
                    label: this.$t('Shared.UserName'),
                    class: 'text-rigth'
                },
                {
                    key: 'userCode',
                    sortable: true,
                    label: this.$t('employee.UserID'),
                    class: 'text-rigth'
                },
                {
                    key: 'userRoleName',
                    sortable: true,
                    label: this.$t('userHeader.Role'),
                    class: 'text-rigth'
                },
                {
                    key: 'isActive',
                    sortable: true,
                    label: this.$t('Shared.Status'),
                    class: 'text-rigth'
                },
                {
                    key: 'expirationDateUser',
                    sortable: true,
                    label: this.$t('userHeader.pExpDate'),
                    class: 'text-rigth'
                },
                {
                    key: 'isSupervisorTranslated',
                    sortable: true,
                    label: this.$t('userHeader.IsSupervisor'),
                    class: 'text-rigth'
                },
                {
                    key: 'canCreateAlertsTranslated',
                    sortable: true,
                    label: this.$t('userHeader.CanCreateAlerts'),
                    class: 'text-rigth'
                },
                {
                    key: 'isVIPTranslated',
                    sortable: true,
                    label: this.$t('userHeader.CanSeeRestricted'),
                    class: 'text-rigth'
                },
                {
                    key: 'isEmployee',
                    sortable: true,
                    label: this.$t('UnifiedProfile.IsEmployee'),
                    class: 'text-rigth'
                },
                {
                    key: 'isDoctor',
                    sortable: true,
                    label: this.$t('UnifiedProfile.IsDoctor'),
                    class: 'text-rigth'
                }
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            selected: [],
            isReadOnly: false,
            RoleList: [],
            Rol: {
                code: '',
                description: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    computed: {
        sortOptions() {
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        }
    },

    methods: {
        AddUser() {
            if (this.hasPermissionAdd()) {
                this.Mode = 'Add';
                this.emitDataforFavorites();
                EventBus.$emit('onUpdatedMenu', '');
                this.$router
                    .push({ name: 'unifiedprofile-add', params: { id: this.$route.params.id } })
                    .catch(() => {});
            } else {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('userHeader.pAddMsg'),
                    'errorAutoHide'
                );
            }
        },

        SearchUsers() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
        },

        EditUser(row) {
            this.userCode = row.userCode;
            this.Mode = 'Edit';
            this.$router.push({ name: 'unifiedprofile-details', params: { id: this.userCode } });
        },

        getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            this.parameter.Status = this.status.value;
            this.parameter.RoleCode = this.Rol.code;
            this.parameter.PasswordStatus = this.passwordStatus.value;
            this.parameter.CheckEmployeeDoctor = true;
            UsersService.getAll(this.parameter)
                .then(response => {
                    if (response.status == '200') {
                        if (response.data.length > 0) {
                            this.items = response.data;
                            this.items.forEach(function(element) {
                                if (element.expirationDateUser)
                                    element.expirationDateUser = Utils.formatterDateToString(
                                        element.expirationDateUser
                                    );

                                if (
                                    element.expirationDateUser !== null &&
                                    element.expirationDateUser !== '' &&
                                    element.expirationDateUser !== undefined
                                ) {
                                    if (
                                        Utils.ValidateDate(
                                            element.expirationDateUser,
                                            Utils.getShortDateFormat()
                                        )
                                    ) {
                                        let date = moment();
                                        let exp = moment(element.expirationDateUser)
                                            .utc(
                                                element.expirationDateUser,
                                                Utils.getShortDateFormat()
                                            )
                                            .format('YYYY-MM-DD HH:mm');
                                        let now = moment().utc(date);
                                        if (now.isAfter(exp)) {
                                            element.expired = 'Password Expired';
                                        } else {
                                            element.expired = 'Password Not Expired';
                                        }
                                    }
                                }
                            });
                            let headerString = response.headers['x-pagination'];
                            this.totalRows = JSON.parse(headerString).TotalCount;
                        } else {
                            this.ShowMessageIsEmpty = true;
                        }
                    } else {
                        this.ShowMessageIsEmpty = true;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getListing();
        },

        PerPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getListing();
        },

        onRowSelected(items) {
            this.selected = items;
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },

        clearSelected() {
            this.$refs.selectableTable.clearSelected();
        },

        selectThirdRow() {
            this.$refs.selectableTable.selectRow(2);
        },

        unselectThirdRow() {
            this.$refs.selectableTable.unselectRow(2);
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        ChangeStatus(status) {
            // this.status.value = status ? status.value : '';
            this.status = { value: '' };
            if (status) {
                this.status.value = status.value;
                this.status.text = status.text;
                this.status.selected = status.selected;
            }
            this.items = [];
            this.totalRows = 0;
            this.getListing();
        },
        ChangePasswordStatus(status) {
            this.passwordStatus = { value: '' };
            if (status) {
                this.passwordStatus.value = status.value;
                this.passwordStatus.text = status.text;
                this.passwordStatus.selected = status.selected;
            }
            this.items = [];
            this.totalRows = 0;
            this.getListing();
        },
        ChangeRol(rol) {
            this.Rol = { code: '' };
            if (rol) {
                this.Rol.code = rol.code;
                this.Rol.description = rol.description;
            }
            this.items = [];
            this.totalRows = 0;
            this.getListing();
        },
        async getRols() {
            await UsersService.getRols()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.RoleList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    async mounted() {
        await this.getRols();

        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getListing();
    }
};
</script>
